import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import { useHistory } from 'react-router-dom'
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import ReceiptIcon from '@mui/icons-material/Receipt';
import FeedIcon from '@mui/icons-material/Feed';
import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { filePDF } from "../../assets/pdf";
import { useDispatch, } from "react-redux";
import { SocietiesList } from './SocietiesList'
import Dialog from '@mui/material/Dialog';
import {snackAction} from '../../components/CustomSnakbar.jsx'
import { useSnackbar } from "notistack";
import { Typography } from '@mui/material';
import {ROUTES} from '../../constants'
import {countryHasExirosByCountryId} from "../../data/CountriesExiros.js"
//TODO: armar constantes para las URL

const useStyles = makeStyles((theme) => ({
  buttomHome: {
    width: "100%",
    marginTop: "10px",
    padding: "10px",
    borderRadius: "5px"
  },
}));
export const Home = ({email}) => {

  const { enqueueSnackbar } = useSnackbar();
  const MEXICO =3;
  const ARGENTINA =1;
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const categories = useSelector(store => store.masterData.categories);
  const documentType = useSelector(store => store.documentType.data);
  const societies = useSelector(store => store.societies.data.filter(x=>x.selected));
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRedirect = (path) => (e) => {
    e.preventDefault();
    if (path) history.push(path)
  }

  const handleRedirectContact = (value) => {

    let categoryId = categories.find(x => x.description === value)?.id ?? 0;
    history.push(`${ROUTES.CONTACT_FORM}${categoryId}`);
  }

  const handleRedirectTickets = () => {
    history.push(`${ROUTES.TICKETS_LIST}`);
  }

  const handleRedirectAccountStatus = () => {
    history.push(`${ROUTES.ACCOUNT_STATUS}`);
  }

  //TODO: hacer un solo handler
  const handleRedirectExternal = (url) => {
    window.open(url)
  }

  const handleClickDownload = (pdf) => {
    window.open(pdf)   
  }

  useEffect(() => {
    if(societies && societies.length === 0){
      enqueueSnackbar("Debe seleccionar un país", { variant: "warning", action: snackAction, autoHideDuration: 2000 });
      history.push(ROUTES.SELECT_COUNTRY)
    }
  }, [enqueueSnackbar, history, societies])
  return (<>
    {
      societies && societies.length > 0 ?(
        <Grid container rowSpacing={1} justifyContent="center" columnSpacing={{ xs: 2, sm: 2, md: 3 }}>
          <Grid item xs={4}>
            <Card sx={{
              minWidth: 275, border: "0.5px solid green", "&:hover": {
                boxShadow: "0px 0px 7px 0px rgba(0,0,0,0.75)"
              }
            }}>
              {GetMenuForCountry(handleRedirectExternal, classes, handleRedirect, documentType, societies)}
            </Card>
          </Grid>
          <Grid item xs={4}>
            <Card sx={{
              minWidth: 275, border: "0.5px solid green", "&:hover": {
                boxShadow: "0px 0px 7px 0px rgba(0,0,0,0.75)"
              }
            }}>
              <CardContent>
                <Stack direction="row" alignItems="center" justifyContent="center" justifyItems="center" spacing={2}>
                  <label>
                    <IconButton color="primary"
                      aria-label="upload picture"
                      component="span"
                      style={{
                        heigth: "100%", width: "100%",
                      }}
                    >
                      <ConnectWithoutContactIcon style={{ fontSize: 90 }} />
                    </IconButton>
                  </label>
                </Stack>
                {/* <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
                  <Button color="secondary" variant="contained" onClick={() => handleRedirectContact("")} className={classes.buttomHome}>Consultas</Button>
                </Stack> */}
                <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
                  <Button color="secondary" variant="contained" onClick={handleRedirect(ROUTES.TICKETS_LIST)} className={classes.buttomHome}><Typography>Consultas</Typography></Button>
                </Stack>
                <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
                  <Button color="secondary" variant="contained" onClick={() => handleRedirectAccountStatus("")} className={classes.buttomHome}><Typography>Estado Cuenta</Typography></Button>
                </Stack>

                {
                  societies.filter(x => x.countryId === MEXICO&&x.selected).length > 0 &&
                  <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
                    <Button color="secondary" variant="contained" onClick={() => handleRedirectContact("Entrega Complementos Pago MX")} className={classes.buttomHome}><Typography>Entrega Complementos Pago MX</Typography></Button>
                  </Stack>
                }

              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={4}>
            <Card sx={{
              minWidth: 275, border: "0.5px solid green", "&:hover": {
                boxShadow: "0px 0px 7px 0px rgba(0,0,0,0.75)"
              }
            }} >
              <CardContent >
                <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
                <label >
                    <IconButton color="primary" aria-label="upload picture" component="span"
                      // onClick={handleRedirect("/Invoice")}
                    >
                      <FeedIcon style={{ fontSize: 90 }} />
                    </IconButton>
                  </label>
                </Stack>
                <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
                  <Button color="secondary" variant="contained" onClick={handleClickOpen} className={classes.buttomHome}>
                 
                  <Grid 
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  >
                  <Typography>
                  Legajo Impositivos
                    </Typography>
                    <Typography >
                      Sociedades TEIC
                    </Typography>                
                  </Grid>  
                  </Button>
                </Stack>
                {
                  societies.filter(x => x.countryId === ARGENTINA&&x.selected).length > 0 &&
                  <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
                    <Button color="secondary" variant="contained" onClick={() => handleClickDownload(filePDF.INFORMATION.POLITICAS_AR)} className={classes.buttomHome}><Typography>Políticas CUPA (AR)</Typography></Button>
                  </Stack>
                }
                {
                  societies.filter(x => x.countryId === MEXICO&&x.selected).length > 0 &&
                  <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
                    <Button color="secondary" variant="contained" onClick={() => handleClickDownload(filePDF.INFORMATION.POLITICAS_MX)} className={classes.buttomHome}><Typography>Políticas CUPA (MX)</Typography></Button>
                  </Stack>
                }
                
                <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
                  <Button color="secondary" variant="contained" onClick={() => handleRedirectExternal("https://techintcupa.blob.core.windows.net/public/InstructivoPortalCUPA.rar")} className={classes.buttomHome}><Typography>Instructivos Proceso</Typography></Button>
                </Stack>
                <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
                  <Button color="secondary" variant="contained" onClick={() => handleRedirectExternal("https://suppliers-exiros.ivalua.app/page.aspx/es/buy/homepage/sup")} className={classes.buttomHome}><Typography>Acceso Portal Proveedor</Typography></Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
          {

            societies && societies.length > 0 &&
            <Dialog maxWidth="lg" onClose={handleClose} open={open}>
              <SocietiesList open={open} societies={societies} handleClickDownload={handleClickDownload} isDownload={true} />
            </Dialog>
          }
        </Grid>): "sin sociedades selecionadas"
    }
  </>
  );
};

const GetMenuForCountry = (handleRedirectExternal, classes, handleRedirect, documentType, societies) => {
  const hasExiros = countryHasExirosByCountryId(societies[0]?.countryId)
  if (hasExiros) {
    return <MenuForCountriesWithExiros
      handleRedirectExternal={handleRedirectExternal}
      classes={classes}
      handleRedirect={handleRedirect}
      documentType={documentType}
    />
  }
  else {
    return <MenuForCountriesWithoutExiros handleRedirectExternal={handleRedirectExternal}
      classes={classes}
      handleRedirect={handleRedirect}
      documentType={documentType} />
  }


}


const MenuForCountriesWithExiros = ({ handleRedirectExternal, classes, handleRedirect, documentType }) => {
  return <Card sx={{
    minWidth: 275, border: "0.5px solid green", "&:hover": {
      boxShadow: "0px 0px 7px 0px rgba(0,0,0,0.75)"
    }
  }}>
    <CardContent>
      <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
        <label>
          <IconButton color="primary" aria-label="upload picture" component="span">
            <ReceiptIcon style={{ fontSize: 90 }} />
          </IconButton>
        </label>
      </Stack>
      <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
        <Button color="secondary" variant="contained" href="#" onClick={() => handleRedirectExternal("https://suppliersworkplace.exiros.com/EPR/Portal/ ")} className={classes.buttomHome}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Typography>
              Factura Materiales
            </Typography>
            <Typography>
              c/Pedidos Compra
            </Typography>
          </Grid>
        </Button>
      </Stack>
      <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
        <Button color="secondary" variant="contained" href="#" onClick={() => handleRedirectExternal("https://suppliersworkplace.exiros.com/EPR/Portal/ ")} className={classes.buttomHome}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Typography>
              Factura Servicios
            </Typography>
            <Typography>
              c/Pedidos Compra
            </Typography>
          </Grid>
        </Button>
      </Stack>
      <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
        <Button color="secondary" variant="contained" href="#" onClick={() => handleRedirectExternal("https://suppliersworkplace.exiros.com/EPR/Portal/ ")} className={classes.buttomHome}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Typography>
              Factura sin Pedido Compra
            </Typography>
            <Typography>
              Nota Debito
            </Typography>
          </Grid>
        </Button>
      </Stack>
      <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
        <Button color="secondary" variant="contained" href="#" onClick={handleRedirect(ROUTES.DOCUMENTS + documentType.find(x => x.id === 2).description)} className={classes.buttomHome}><Typography>Facturas Anticipos</Typography></Button>
      </Stack>
      <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
        <Button color="secondary" variant="contained" href=" #" onClick={handleRedirect(ROUTES.DOCUMENTS + documentType.find(x => x.id === 5).description)} className={classes.buttomHome}><Typography>Notas Crédito</Typography></Button>
      </Stack>
      <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
        <Button color="secondary" variant="contained" href="#" onClick={handleRedirect(ROUTES.DOCUMENTS + documentType.find(x => x.id === 8).description)} className={classes.buttomHome}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Typography>
              Facturas Proveedores
            </Typography>
            <Typography>
              Exterior
            </Typography>
          </Grid>
          </Button>
      </Stack>
    </CardContent>
  </Card>;
}


const MenuForCountriesWithoutExiros = ({ handleRedirectExternal, classes, handleRedirect, documentType }) => {
  return <Card sx={{
    minWidth: 275, border: "0.5px solid green", "&:hover": {
      boxShadow: "0px 0px 7px 0px rgba(0,0,0,0.75)"
    }
  }}>
    <CardContent>
      <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
        <label>
          <IconButton color="primary" aria-label="upload picture" component="span">
            <ReceiptIcon style={{ fontSize: 90 }} />
          </IconButton>
        </label>
      </Stack>
      <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
        {/* FIXME: Esta hardcodeados */}
        <Button color="secondary" variant="contained" href=" #" onClick={handleRedirect(ROUTES.DOCUMENTS + documentType.find(x => x.id === 1).description)} className={classes.buttomHome}>Facturas</Button>
        
      </Stack>
      <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
        <Button color="secondary" variant="contained" href="#" onClick={handleRedirect(ROUTES.DOCUMENTS + documentType.find(x => x.id === 2).description)} className={classes.buttomHome}>Facturas Anticipos</Button>
      </Stack>
      <Stack direction="row" alignItems="center" justifyItems="center" justifyContent="center">
        <Button color="secondary" variant="contained" href=" #" onClick={handleRedirect(ROUTES.DOCUMENTS + documentType.find(x => x.id === 5).description)} className={classes.buttomHome}>Notas Crédito</Button>
      </Stack>
    </CardContent>
  </Card>;
}